import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { type Observable, finalize, map, shareReplay, tap } from 'rxjs';

import { AUTH_CONFIG } from './auth.config';
import { SessionService } from './session.service';

@Injectable({ providedIn: 'root' })
export class SessionRefreshService {
  private readonly http = inject(HttpClient);
  private readonly session = inject(SessionService);
  private readonly config = inject(AUTH_CONFIG);

  private inFlight: Observable<boolean> | null = null;

  refresh(): Observable<boolean> {
    if (this.inFlight) {
      return this.inFlight;
    }
    this.inFlight = this.http
      .post(`${this.config.apiUrl}/authentication/refresh-tokens`, {}, { withCredentials: true })
      .pipe(
        tap(() => this.session.refresh()),
        map(() => this.session.isLoggedIn()),
        finalize(() => (this.inFlight = null)),
        shareReplay({ bufferSize: 1, refCount: true }),
      );
    return this.inFlight;
  }
}
